// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2LmeV","inner":"Footer_inner__1m1UA","nextIcon":"Footer_nextIcon__2H_DL","innerLeft":"Footer_innerLeft__3TeLb"};